module.exports = __webpack_public_path__ + "assetsclientes/img/no-image-dark.d9e9c3c2.jpg";